import { Link } from "react-router-dom";
import SEO from "../ui/SEO.jsx";

export default function NotFound() {
  return (
    <div className="text-center py-20">
      <SEO title="Não encontrado" />
      <div className="font-serif text-7xl text-accent mb-4">404</div>
      <h1 className="font-serif font-medium text-3xl mb-4">
        Essa página não existe.
      </h1>
      <p className="text-ink-soft mb-8">
        Talvez tenha mudado de endereço, ou nunca esteve aqui.
      </p>
      <Link
        to="/"
        className="inline-block bg-ink text-bg px-6 py-3 rounded-xl font-semibold no-underline"
      >
        Voltar para o início
      </Link>
    </div>
  );
}
